import { useQuery } from '@apollo/client/react/hooks';
import { useLocation } from 'react-router-dom';
import { parse } from 'querystring';
import { getLocaleFromPathname, getIntlValidLocale } from '@app/helpers/locale';
import { generateRoute } from '@app/components/ProductFinder/url';
import { PRODUCT_FINDER_SEGMENT } from '@app/routes/routes';
import contentPageQuery from './query';
import { ProductFinderContentPageQuery_productFinderContentPage_sections as Section } from './__generated__/ProductFinderContentPageQuery';

export interface ContentPageHookOutput {
  contentPageLoading: boolean;
  contentPageSections: Section[];
}

export default function useContentPage(
  menuSlugs: string[]
): ContentPageHookOutput {
  const location = useLocation();
  const category = menuSlugs
    ? `/${generateRoute([PRODUCT_FINDER_SEGMENT, ...menuSlugs])}/`
    : '';
  const { previewToken } = parse(location.search?.substring(1));

  const { loading, data } = useQuery(contentPageQuery, {
    variables: {
      category,
      language: getIntlValidLocale(getLocaleFromPathname(location.pathname)),
      previewToken,
    },
  });

  return {
    contentPageLoading: loading,
    contentPageSections: data?.productFinderContentPage?.sections,
  };
}
